import useSocialAuthLocale from "@casino/legacy/client/features/SocialAuth/hooks/useSocialAuthLocale";
import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useSite from "@casino/legacy/client/hooks/useSite";
import authType from "@casino/legacy/shared/utils/auth/authType";
import SessionStorage from "@casino/legacy/shared/utils/storage/SessionStorage";
import type { ErrorsFragment } from "@workspace/casino_core/mutations/UpdateUserSettingsMutation";

type HandleRegisterArgs = {
  accessToken: string;
  type: AuthType;
  state?: string;
  errors?: Array<ErrorsFragment | undefined>;
};

const useHandleRegister = () => {
  const router = useRouter();
  const { siteConfig } = useSite();
  const [getLocale] = useSocialAuthLocale();

  const handleRegister = async ({
    type,
    accessToken,
    state,
    errors,
  }: HandleRegisterArgs) => {
    const missingFields = getMissingFields(errors);
    SessionStorage.setItem("social_auth_missing_fields", missingFields);
    authType.set(type);
    SessionStorage.setItem("social_auth_token", accessToken);
    const redirectUrl = getRedirectFromState(state);
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    const redirectPath = `/complete-registration?redirect=${encodedRedirectUrl}`;
    const lang = getLocale() ?? router.locale;
    return router.push(redirectPath, undefined, {
      shallow: false,
      locale: lang === siteConfig.defaultLang ? undefined : lang,
    });
  };
  return handleRegister;
};

const getRedirectFromState = (state = "{}") => JSON.parse(state).redirect;

const getMissingFields = (errors?: Array<ErrorsFragment | undefined>) =>
  errors
    ?.filter((el) => el?.message === "IS_REQUIRED")
    .map((el) => el?.params?.[0]?.value)
    .join(",") ?? "";

export default useHandleRegister;
